import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/responsive.css';
import HomePage from './pages/HomePage';
import AllArticles from './pages/AllArticles';
import ArticleDetail from './pages/ArticleDetail';
import AllSpecializations from './pages/AllSpecializations';
import PublishPractice from './pages/PublishPracticeEnhanced';
import Organizations from './pages/OrganizationsPremium';
import AboutGewo from './pages/AboutGewo';
import SurgeriesProcedures from './pages/SurgeriesProcedures';
import Security from './pages/Security';
import DataSecurity from './pages/DataSecurity';
import LegalPolicies from './pages/LegalPolicies';
import InnovationChallenge from './pages/InnovationChallenge';
import VideoConsultations from './pages/VideoConsultations';
import TechnologyEcosystem from './pages/TechnologyEcosystemEnhanced';
import FindDoctors from './pages/FindDoctors';
import DoctorProfile from './pages/DoctorProfile';
import WomensHealth from './pages/WomensHealth';
import LifestyleDiseases from './pages/LifestyleDiseases';
import MentalHealthServices from './pages/MentalHealthServices';
import GeriatricAdultCare from './pages/GeriatricAdultCare';
import InnovationFAB from './components/InnovationFAB';
import Partners from './pages/Partners';
import HospitalPartnerships from './pages/HospitalPartnerships';
import ApiPartners from './pages/ApiPartners';
import InnovationPartnership from './pages/InnovationPartnership';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/articles" element={<AllArticles />} />
          <Route path="/article/:slug" element={<ArticleDetail />} />
          <Route path="/specializations" element={<AllSpecializations />} />
          <Route path="/publish-practice" element={<PublishPractice />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/about" element={<AboutGewo />} />
          <Route path="/surgeries" element={<SurgeriesProcedures />} />
          <Route path="/security" element={<Security />} />
          <Route path="/data-security" element={<DataSecurity />} />
          <Route path="/legal" element={<LegalPolicies />} />
          <Route path="/innovation-challenge" element={<InnovationChallenge />} />
          <Route path="/video-consultations" element={<VideoConsultations />} />
          <Route path="/technology-ecosystem" element={<TechnologyEcosystem />} />
          <Route path="/find-doctors" element={<FindDoctors />} />
          <Route path="/doctor/:id" element={<DoctorProfile />} />
          <Route path="/womens-health" element={<WomensHealth />} />
          <Route path="/lifestyle-diseases" element={<LifestyleDiseases />} />
          <Route path="/mental-health-services" element={<MentalHealthServices />} />
          <Route path="/geriatric-adult-care" element={<GeriatricAdultCare />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/hospital-partnerships" element={<HospitalPartnerships />} />
          <Route path="/api-partners" element={<ApiPartners />} />
          <Route path="/innovation-partnership" element={<InnovationPartnership />} />
        </Routes>
        
        <InnovationFAB />
      </BrowserRouter>
    </div>
  );
}

export default App;

